import AuthManager from '@/lib/AuthManager'
import authServices from '@/services/auth'

export default async (to, from, next) => {
  try {
    if (to.meta.public) return next()
    const { admin } = await authServices.fetchCurrentUser()
    if (admin) return next()
    AuthManager.logOff()
    next({ name: 'auth.signIn', replace: true })
  } catch (e) {
    AuthManager.logOff()
    next({ name: 'auth.signIn', replace: true })
  }
}
